import { useRef } from 'react';
import { useNavigate } from "react-router";
import { fetchToken } from "./Auth";
import { TitleImage } from "./BaseComponents";

export default function LandingPage() {
  const navigate = useNavigate();

  const enter = () => {
    if (fetchToken()) {
      navigate("/profile");
    } else {
      navigate("/login");
    };
  };

  const audioRef = useRef(null);

  const handleLogoClick = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio("music/02. At Doom's Gate.mp3");
    }
    const audio = audioRef.current;
    audio.currentTime = 0;
    audio.play();
  };

  return (
    <div className="App-body">
      {TitleImage()}
      <button className='No-border-button' onClick={handleLogoClick}>
        <img src="images/swampyankeetech_logo.png" alt="swampyankeetech logo" />
      </button>
      <br />
      <div className="ContentBorderLandingPage">
        <p>
          lp spinning: <a href="https://www.youtube.com/watch?v=mDTBlJ27gqQ">howlin wolf - moaning in the moonlight</a>
        </p>
        <button onClick={enter}>enter</button>
      </div>
    </div>
  );
}
